export const Operational_Q4_Check_Details = [
  {
    CheckId: "broker_general_logging_check",
    Description:
      "Amazon MQ Message brokers should have general logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_cloudwatch_logging_check",
    Description: "Enable CloudWatch logging for RDS databases ",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "broker_audit_logging_check",
    Description: "Amazon MQ Message brokers should have audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "lambda_permission_to_cloudwatch_log_check",
    Description:
      "Lambda function should have enough permissions to write logs in CloudWatch log group.",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "redshift_cluster_logging_check",
    Description: "Redshift cluster audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "api_gateway_active_tracing_is_enabled_for_stages",
    Description:
      "API Gateway REST API stages must have AWS X-Ray tracing enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "emr_cluster_logging_check",
    Description: "EMR cluster logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "blockchain_fabric_peer_node_logs_enabled",
    Description:
      "Peer node logs allow you to debug timeout errors associated with proposals and identify rejected proposals",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "amb_fabric_node_chaincode_logging_check",
    Description: "Fabric peer node chaincode logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "documentdb_cluster_audit_logging_on",
    Description: "Ensure DocDB cluster audit logging is turned on",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "are_global_management_events_logged",
    Description:
      'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_stage_api_logging_enabled",
    Description: "Ensure stage API logging enabled on API Gateway",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "neptune_cluster_audit_logging_check",
    Description: "Neptune audit logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_analytics_application_log_to_cloudwatch_check",
    Description: "Kinesis analytics application log to CloudWatch",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_enabled",
    Description: "Enable CloudTrail",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elbv2_nlb_tls_logging_check",
    Description: "Do NLBs with TLS listeners have access logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "amb_fabric_member_ca_logging_check",
    Description: "Fabric member CA logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_cloudwatch_log_forwarding_enabled",
    Description:
      "Ensure log forwarding enabled on Directory Service directory, this helps you to meet your security monitoring, audit, and log retention policy requirements by providing transparency of the security events in your directory.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "appmesh_logging_check",
    Description:
      "App Mesh virtual nodes should define an HTTP access log path to enable log exports for Envoy proxies",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "is_cloudwatch_logging_enabled",
    Description:
      "Ensure CloudWatch logging enabled for CodeBuild for audit pupose.",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Operational_Q4_rds_instance_cloudwatch_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "0c58ea13-27f5-4a9f-9ed7-67dd350653a5",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "f0f58171-881f-4c22-b5e3-9918c26a7a72",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Operational_Q4_lambda_permission_to_cloudwatch_log_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:24",
      FindingId: "4e6c063b-da65-4d00-8d06-6833ab07bbe1",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:25",
      FindingId: "5b05a422-db7d-41bd-8a21-e9ad6fd624f0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:25",
      FindingId: "49e49bd1-95c3-45d3-90d0-bae8b159d726",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:25",
      FindingId: "6970d586-b082-4ba2-99ea-4770285c4f25",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:25",
      FindingId: "7aa52888-da12-4c82-9ba3-863f89e4e3fe",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_permission_to_cloudwatch_log_check",
      CreatedAt: "2023-04-25 12:24:25",
      FindingId: "e61b17b8-83ef-4a59-8760-dbf9137b4866",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "This check verifies whether lambda function is having required permissions to write log files into CloudWatch Log group.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 6,
};

export const Operational_Q4_api_gateway_active_tracing_is_enabled_for_stages = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_active_tracing_is_enabled_for_stages",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "4497f74d-08be-4bdb-8a67-107103e13c64",
      Metadata: {
        TaskRefId: "fead594c-9a18-4d94-a3cf-2e678eb3de22",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "X-Ray active tracing provides real-time metrics of user requests that flow through your API Gateway REST API operations and connected services. This checks verifies if AWS X-Ray active tracing is enabled for your Amazon API Gateway REST API stages.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "2edfnla881/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_active_tracing_is_enabled_for_stages",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "acbab801-2470-4412-b5ab-7e482851998f",
      Metadata: {
        TaskRefId: "fead594c-9a18-4d94-a3cf-2e678eb3de22",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "X-Ray active tracing provides real-time metrics of user requests that flow through your API Gateway REST API operations and connected services. This checks verifies if AWS X-Ray active tracing is enabled for your Amazon API Gateway REST API stages.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "2edfnla881/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Operational_Q4_are_global_management_events_logged = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "de0b470e-8645-4014-b67c-d7224173e44d",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "e05c121c-2495-4b33-bad9-67e7403d7ef6",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};

export const Operational_Q4_is_stage_api_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "849b76c3-191c-454d-850b-95eff67cfc5b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "fec6352f-2ec4-489d-99c3-c8341ba45639",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Operational_Q4_neptune_cluster_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_cluster_audit_logging_check",
      CreatedAt: "2023-04-25 12:24:43",
      FindingId: "863bb2f2-3a6b-46aa-8c1a-c39654f1ddeb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "To audit Amazon Neptune DB cluster activity, enable the collection of audit logs by setting a DB cluster parameter. When audit logs are enabled, you can use it to log any combination of supported events. You can view or download the audit logs to review them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbclusternc-h0etehondbyg",
      ResourceType: "NeptuneCluster",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Operational_Q4_cloud_trail_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_enabled",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "2e304821-7f04-4a40-9545-e7f5453daac9",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "telemetry",
      Recommendation:
        "Ensure that CloudTrail is enabled for all AWS regions in order to increase the visibility of the API activity in your AWS account for security and management purposes.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};

export const Operational_Q5_Check_Details = [
  {
    CheckId: "image_builder_pipeline_tests_enabled",
    Description:
      "Ensure you add test in imagebuilder pipeline to make sure your created images work properly",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "out_of_date_ec2_amis",
    Description: "Outdated EC2 AMIs",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ecr_repo_vuln_scan_check",
    Description: "Enable automatic scan on push for ECR repositories",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Operational_Q5_image_builder_pipeline_tests_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Operational_Q5_out_of_date_ec2_amis = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "out_of_date_ec2_amis",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "780eac76-9df2-466d-8d85-f4465af62d60",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "dev-integ",
      Recommendation:
        "Ensure that your existing AWS Amazon Machine Images (AMIs) are not older than 180 days in order to ensure their reliability and to meet security and compliance requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-092c18574fce16603",
      ResourceType: "Image",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "out_of_date_ec2_amis",
      CreatedAt: "2023-04-25 12:24:41",
      FindingId: "826682ac-f0b1-4439-b710-8d3940f907a0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "dev-integ",
      Recommendation:
        "Ensure that your existing AWS Amazon Machine Images (AMIs) are not older than 180 days in order to ensure their reliability and to meet security and compliance requirements.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "ami-0a8d4563854aec173",
      ResourceType: "Image",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};

export const Operational_Q5_ecr_repo_vuln_scan_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ecr_repo_vuln_scan_check",
      CreatedAt: "2023-04-25 12:24:49",
      FindingId: "27907761-5caa-4e2e-8d70-1b19990625a5",
      Metadata: {
        TaskRefId: "3880ba12-0bc0-4cf1-b599-3e4c3d33ba71",
      },
      PillarId: "operationalExcellence",
      QuestionId: "dev-integ",
      Recommendation:
        "It is a best practice to scan images pushed to ECR repositories. This check verifies if 'Scan on push' configuration is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:ecr:us-east-1:181570489212:repository/warf-repo-ba272900-e354-11ed-860e-0e88695980d3",
      ResourceType: "Repository",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const Operational_Q8_Check_Details = [
  {
    CheckId: "rds_auto_minor_version_upgrade_check",
    Description: "AWS RDS automatic minor version upgrades must be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ecs_cluster_container_insights_check",
    Description:
      "Use CloudWatch Container Insights to collect, aggregate, and summarize metrics and logs from your containerized applications and microservices. ",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "lambda_is_tracing_enabled",
    Description: "Enable tracing for AWS Lambda functions",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cfn_drift_check",
    Description: "CloudFormation drift check",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cluster_enhanced_monitoring_check",
    Description: "MSK Cluster enhanced monitoring used",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "kinesis_enhanced_monitoring_check",
    Description: "Kinesis data stream enhanced monitoring enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_instance_performance_insights_check",
    Description: "RDS DB performance insights enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Operational_Q8_rds_auto_minor_version_upgrade_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_auto_minor_version_upgrade_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "460e1abb-208d-4a70-90a0-aacb7c50c75f",
      Metadata: {
        TaskRefId: "5b12c667-c0ef-4363-99e2-4bacbd54dfb0",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "RDS Databased  can be upgraded with major and minor upgrades. Minor upgrades helps maintain a secure and stable RDS with minimal impact on the application. It is a best practice to enable automatic minor upgrades.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_auto_minor_version_upgrade_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "6e9fb8a7-8644-4d02-958d-600b9468cd80",
      Metadata: {
        TaskRefId: "5b12c667-c0ef-4363-99e2-4bacbd54dfb0",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "RDS Databased  can be upgraded with major and minor upgrades. Minor upgrades helps maintain a secure and stable RDS with minimal impact on the application. It is a best practice to enable automatic minor upgrades.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Operational_Q8_ecs_cluster_container_insights_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Operational_Q8_lambda_is_tracing_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "17f0520a-bbd6-408e-adde-916bb391ac27",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEC2NonCompliantAM-2horqoP4qTLF",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "87fe3fc6-663d-4b2e-affa-beb5859aad56",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-KMSC-KMSDisableLambdaFunction-N8lhOjociwfc",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "91eafbec-2b2f-4b78-922f-65a9bc024908",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-1-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "b3dccf2e-2adb-4514-b8fb-efb82417ca2a",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-EC2N-wartestEbsEncryptionByDe-vaX5746gPaMX",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "c3fe1dea-6f7c-45c1-9f15-4cd1b66d39a2",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:HumanTech-Production-RDSNonC-RDSSnapshotNCFunction-wjs23Y39nThw",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "lambda_is_tracing_enabled",
      CreatedAt: "2023-04-25 12:24:19",
      FindingId: "d8374a90-1861-411f-b54d-cf4259e8950f",
      Metadata: {
        TaskRefId: "3b704e42-0906-493d-bebd-868035b9c8e2",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "You can use AWS X-Ray to visualize the components of your application, identify performance bottlenecks, and troubleshoot requests that resulted in an error. Your Lambda functions send trace data to X-Ray, and X-Ray processes the data to generate a service map and searchable trace summaries. This check verifies if Tracing is enabled for AWS Lambda functions.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:lambda:us-east-1:181570489212:function:Hello-World-2-ba10e1e0-e354-11ed-a58b-0ef5781b88cf",
      ResourceType: "Lambda",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};
export const Operational_Q8_cfn_drift_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "3bceaed8-dbbf-4ba2-9343-a41a4a788625",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-EC2NonCompliant",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "4845a786-6168-48b1-8411-9db87dbcaa20",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-RDSNonCompliant-HJK6AKDK1CD",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "60a2520c-0f69-4aa9-adf1-bc9ff8bd43a4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-UnusedResourcesNonCompliant-109RHAL4LPGV7",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "084f8e13-5c32-490e-92bf-7639df3840ae",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-KinesisStreamNonCompliant-15P6JJD70MQXI",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "2fe276ef-728b-43e6-8002-0a9623ad70a9",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-CloudtrailNonCompliant-19WQGRB5R076E",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "317ce7e0-ac6d-42e8-b7f7-679392094306",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "MontyCloud-OnBoarding-Role-SNSTopicPermissions-Q4ZCM9Y6A4YP",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "4f66d96b-021b-45c6-92e3-b9c47ed818d8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-ApigatewayNonComplaint-1LVK9AHJ2JRJX",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "5b4b74ea-bf80-47ce-b93f-58dd56cda410",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-LambdaNonCompliant-K7G7I6PIX3SJ",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "693b0c9f-3a92-458a-aa97-05b03955875e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "MontyCloud-OnBoarding-Role-SecurityBotPermissions-1OIYAMFRAAYUD",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:36",
      FindingId: "6a3d7892-ae67-437e-8f45-39c243578477",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-SNSNonComplaint-MXE1GQPV7E3Q",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 19,
};
export const Operational_Q8_cluster_enhanced_monitoring_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Operational_Q8_kinesis_enhanced_monitoring_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kinesis_enhanced_monitoring_check",
      CreatedAt: "2023-04-25 12:24:15",
      FindingId: "d5144d01-36ac-49e1-9aff-608fd52672fd",
      Metadata: {
        TaskRefId: "a7d327f1-e901-4138-bf61-2191c5fcaf71",
      },
      PillarId: "operationalExcellence",
      QuestionId: "workload-health",
      Recommendation:
        "CloudWatch can provide two levels of metric granularity, basic and enhanced. By default, a Kinesis stream has basic-level granularity enabled, which means CloudWatch will collect metrics for the stream as a whole and not for individual shards that make up the stream, To get shard-level metrics, you will need to use the EnableEnhancedMonitoring API to turn on enhanced granularity for a stream. Using this API, you can select which metrics you’d like to enable enhanced monitoring for your stream.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "warf-stream-ba174a80-e354-11ed-8812-0e70d921958f",
      ResourceType: "Kinesis",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Operational_Q8_rds_instance_performance_insights_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Operational_Q10_Check_Details = [
  {
    CheckId: "cfn_drift_check",
    Description: "CloudFormation drift check",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "sns_topic_subscriber_status_check",
    Description: "SNS topics should have active subscriptions",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Operational_Q10_cfn_drift_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "4dc38008-35d7-415e-b49c-112945f1053b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-RDSNonCompliant-HJK6AKDK1CD",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "5baf9636-283a-478f-a8c4-c6f8a6cb3728",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-EC2NonCompliant",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "ace3b53d-9375-4b77-a52e-c1144f3ed7d4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-UnusedResourcesNonCompliant-109RHAL4LPGV7",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "02e8eab1-184a-4fbb-b68f-f84fe4cb98ef",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "MontyCloud-OnBoarding-Role-ComplianceBotPermissions-A03TNK2JVJI",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "0efa6bf2-7562-4fc7-981e-585cce9c9301",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-ECRpublicrepoNC-3F4R6UEL1Z39",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "11919332-5536-4fc6-9249-3c265d9f2cce",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-ELBNonCompliant-WV6QU7RS3OC2",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "2a486c6a-7e89-4af9-b202-1bcdb846a80d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "MontyCloud-OnBoarding-Role-SecurityBotPermissions-1OIYAMFRAAYUD",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "3e01385d-7e59-4166-922e-02db19fcf7ff",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-SNSNonComplaint-MXE1GQPV7E3Q",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "48311fc9-1953-41de-a86c-761d8d326f9d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-DynamodbNonComplaint-RYGTGXLR5XUE",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cfn_drift_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "582dc238-7966-4dcd-996c-12fb1c1fa683",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "CloudFormation stacks should be monitored for configuration drift",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production",
      ResourceType: "Cfn",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 19,
};

export const Operational_Q10_sns_topic_subscriber_status_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_subscriber_status_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "b7e383de-619c-449c-b79f-44c5f268f5d7",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "This check validates whether SNS topic has  subscribers wth confirmed status.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:sns:us-east-1:181570489212:war-test-9b1e",
      ResourceType: "Topic",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_subscriber_status_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "02ddefdf-3122-4aa2-aed8-9f0a43b50beb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "This check validates whether SNS topic has  subscribers wth confirmed status.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-OnBoarding-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_subscriber_status_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "ac6564d3-6c0c-4096-b71a-0ab36387ac0e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "This check validates whether SNS topic has  subscribers wth confirmed status.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "sns_topic_subscriber_status_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "e18f07df-fa4a-4248-9ebb-e2e29b49c2f8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "operationalExcellence",
      QuestionId: "event-response",
      Recommendation:
        "This check validates whether SNS topic has  subscribers wth confirmed status.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:sns:us-east-1:181570489212:MontyCloud-Automation-Task-Notification-Topic",
      ResourceType: "Topic",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 4,
};

export const operationalCheckFindings = {
  [`telemetry_rds_instance_cloudwatch_logging_check`]:
    Operational_Q4_rds_instance_cloudwatch_logging_check,
  [`telemetry_lambda_permission_to_cloudwatch_log_check`]:
    Operational_Q4_lambda_permission_to_cloudwatch_log_check,
  [`telemetry_api_gateway_active_tracing_is_enabled_for_stages`]:
    Operational_Q4_api_gateway_active_tracing_is_enabled_for_stages,
  [`telemetry_are_global_management_events_logged`]:
    Operational_Q4_are_global_management_events_logged,
  [`telemetry_is_stage_api_logging_enabled`]:
    Operational_Q4_is_stage_api_logging_enabled,
  [`telemetry_neptune_cluster_audit_logging_check`]:
    Operational_Q4_neptune_cluster_audit_logging_check,
  [`telemetry_cloud_trail_enabled`]: Operational_Q4_cloud_trail_enabled,

  [`dev-integ_image_builder_pipeline_tests_enabled`]:
    Operational_Q5_image_builder_pipeline_tests_enabled,
  [`dev-integ_out_of_date_ec2_amis`]: Operational_Q5_out_of_date_ec2_amis,
  [`dev-integ_ecr_repo_vuln_scan_check`]:
    Operational_Q5_ecr_repo_vuln_scan_check,

  [`workload-health_rds_auto_minor_version_upgrade_check`]:
    Operational_Q8_rds_auto_minor_version_upgrade_check,
  [`workload-health_ecs_cluster_container_insights_check`]:
    Operational_Q8_ecs_cluster_container_insights_check,
  [`workload-health_lambda_is_tracing_enabled`]:
    Operational_Q8_lambda_is_tracing_enabled,
  [`workload-health_cfn_drift_check`]: Operational_Q8_cfn_drift_check,
  [`workload-health_cluster_enhanced_monitoring_check`]:
    Operational_Q8_cluster_enhanced_monitoring_check,
  [`workload-health_kinesis_enhanced_monitoring_check`]:
    Operational_Q8_kinesis_enhanced_monitoring_check,
  [`workload-health_rds_instance_performance_insights_check`]:
    Operational_Q8_rds_instance_performance_insights_check,
  [`event-response_cfn_drift_check`]: Operational_Q10_cfn_drift_check,
  [`event-response_sns_topic_subscriber_status_check`]:
    Operational_Q10_sns_topic_subscriber_status_check,
};
